import PropTypes from "prop-types";
import { getCardConfig } from "./cardRules";

const CardComponent = ({ cardText, amountText }) => {
  const { bgClass, prefixCard, textColor, logoSrc } = getCardConfig(cardText);

  return (
    <div
      className={`w-[330px] h-[195px] p-4 ${bgClass} shadow-lg rounded-2xl flex flex-col justify-between items-center`}
    >
      {/* Card Number */}
      <div
        className={`w-full text-lg font-oswald font-medium leading-6 break-words ${textColor}`}
      >
        {prefixCard}
        {cardText?.slice(-4)}
      </div>

      <div className="flex justify-center items-center w-full h-full">
        {logoSrc && (
          <img
            src={logoSrc}
            alt="logo"
            className="w-[150px] h-[100px] object-contain mx-auto"
          />
        )}
      </div>

      <div className="w-full flex justify-end items-center gap-3 mt-2">
        <div
          className={`text-lg font-oswald font-medium leading-6 text-right break-words ${textColor}`}
        >
          {amountText}
        </div>
      </div>
    </div>
  );
};

CardComponent.propTypes = {
  cardText: PropTypes.string.isRequired,
  amountText: PropTypes.string.isRequired,
};

export default CardComponent;
